import { render, staticRenderFns } from "./LYC.vue?vue&type=template&id=90d8e5f4&scoped=true"
import script from "./LYC.vue?vue&type=script&lang=js"
export * from "./LYC.vue?vue&type=script&lang=js"
import style0 from "./LYC.vue?vue&type=style&index=0&id=90d8e5f4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90d8e5f4",
  null
  
)

export default component.exports